export interface DatePickerButtonProps {
  value: Date | null;
  onChange: (date: Date | null) => void;
  minDate?: Date;
  maxDate?: Date;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  label?: string;
  className?: string;
  id?: string;
  /** Position of the popover relative to the button. Default: 'bottom' */
  popoverAlign?: 'top' | 'bottom';
}
